import { useDispatch } from 'react-redux'
import { useCallback } from 'react'
import { trackInternalEvent } from '@rio/tracking'
import { useI18n } from 'builder/hooks/useI18n'
import { actions, selectors } from 'builder/modules/resumeEditor'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { ButtonTheme, ButtonV2 } from 'builder/components/Button'
import { useTailoredResumeEdit } from 'builder/components/AutoTailoring/OverviewModal/hooks/useTailoredResumeEdit'

import { FetchStatuses } from 'builder/modules/constants'
export const TailoringFromPublicJobBoardStep2Buttons = () => {
  const { i18n } = useI18n()
  const dispatch = useDispatch()
  const { processingAutoTailoring } = useTypedSelector(selectors.autoTailoringFromPublicJobBoard)
  const { goToPaymentPage, currentResume } = useTailoredResumeEdit()
  const handleSkipTailorManually = useCallback(async () => {
    trackInternalEvent('click_tailor_manually', { label: 'tailored_result' })
    dispatch(actions.skipAutoTailorForPublicJobBoard())
  }, [dispatch])

  const handleUseTailoredResume = useCallback(() => {
    if (!currentResume) return
    dispatch(
      actions.approveResumeRedirect({
        resumeId: currentResume?.id,
        disableRedirect: true,
      }),
    )
    goToPaymentPage()
    trackInternalEvent('click_use_tailored_resume')
  }, [currentResume, dispatch, goToPaymentPage])

  return (
    <>
      <ButtonV2
        theme={processingAutoTailoring === FetchStatuses.loaded ? ButtonTheme.ghost : undefined}
        isDisabled={processingAutoTailoring === FetchStatuses.loading}
        onClick={handleSkipTailorManually}
      >
        {i18n.t(`builder.prefill_resume.auto_tailoring_view.header.skip_tailor_manually`)}
      </ButtonV2>

      <ButtonV2
        isDisabled={processingAutoTailoring === FetchStatuses.loading}
        onClick={handleUseTailoredResume}
      >
        {i18n.t(`builder.prefill_resume.auto_tailoring_view.header.use_tailored_resume`)}
      </ButtonV2>
    </>
  )
}
